<template>
    <div style="margin: auto; max-width: 350px;" class="text-center mt-2">
        <b-container>
            <h1>Sign in to VPNla</h1>

            <form @submit.prevent="login()">
                <b-form-input
                    v-model="email"
                    placeholder="Email address"
                    type="email"
                ></b-form-input>
                <b-form-input
                    v-model="password"
                    placeholder="Password"
                    type="password"
                ></b-form-input>
                <b-button
                    size="lg"
                    block
                    class="mt-2"
                    type="submit"
                    variant="primary"
                    >Login</b-button
                >
                <b-card v-if="loading" class="mt-3">
                    <Spinner text="Logging in" />
                </b-card>
            </form>
        </b-container>
        <LinkCluster />
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import axios from '@/services/axios'
    import Spinner from '@/components/general/spinner'
    import LinkCluster from '@/components/auth/linkcluster'

    export default {
        data() {
            return {
                email: '',
                password: '',
                loading: false
            }
        },
        methods: {
            login() {
                this.loading = true
                axios
                    .post('auth/login', {
                        email: this.email,
                        password: this.password
                    })
                    .then(res => {
                        Cookies.set('auth', JSON.stringify(res.data), {
                            samesite: 'strict',
                            secure: true
                        })
                        window.location.replace('/dashboard')
                    })
                    .catch(error => {
                        this.loading = false
                        this.$bvToast.toast(error.response.data, {
                            title: 'Error',
                            variant: 'warning'
                        })
                    })
            }
        },
        components: {
            LinkCluster,
            Spinner
        }
    }
</script>

<style scoped>
</style>